import { EnvType } from "../services";
import ApiClient from "../api-client";
import IMessengerApiClient from "./messenger-api-client";
import MessengerApiClient from "./messenger-api-client";
import { ListGroupResponse } from "../Types/list-group-response";
import { UserListResponse } from "../Types/user-list-response";
import { ListGroupsResponse } from "../Types/list-groups-response";

export default class MessengerService {
  messengerApiClient: IMessengerApiClient;

  constructor(envType: EnvType) {
    this.messengerApiClient = new MessengerApiClient(new ApiClient(envType), envType);
  }

  async ListAccessibleChatMembers(): Promise<UserListResponse> {
    return await this.messengerApiClient.ListAccessibleChatMembers();
  }
  async ListGroups(): Promise<ListGroupsResponse> {
    return await this.messengerApiClient.ListGroups();
  }
  async ListGroupAndMessages(id: number): Promise<ListGroupResponse> {
    return await this.messengerApiClient.ListGroupAndMessages(id);
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.messengerApiClient.GetApiUrl();
  }
}
